import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RoundComponent } from './round/round.component';
import { IonicModule } from '@ionic/angular';
import { OptionsComponent } from './options/options.component';
import { FormsModule } from '@angular/forms';
import { TimerComponent } from './timer/timer.component';
import { TimerProgressComponent } from './timer-progress/timer-progress.component';
import { TimerOptionsComponent } from './timer-options/timer-options.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { IntervalComponent } from './interval/interval.component';
import { CountdownTimerComponent } from './countdown-timer/countdown-timer.component';
import { FoodFindComponent } from './nutrient/food-find/food-find.component';
import { NutrientChartComponent } from './nutrient/nutrient-chart/nutrient-chart.component';
import { GoogleChartsModule } from 'angular-google-charts';
import { BenefitsComponent } from './nutrient/benefits/benefits.component';
import { MacrosComponent } from './nutrient/macros/macros.component';
import { IntervalCountdownComponent } from './interval-countdown/interval-countdown.component';

@NgModule({
  declarations: [RoundComponent, OptionsComponent, TimerComponent, TimerProgressComponent, TimerOptionsComponent, ProgressBarComponent, IntervalComponent, CountdownTimerComponent, FoodFindComponent, NutrientChartComponent, BenefitsComponent, MacrosComponent, IntervalCountdownComponent],
  imports: [
    FormsModule,
    CommonModule,
    IonicModule,
    GoogleChartsModule.forRoot()
  ],
  exports: [RoundComponent, OptionsComponent, TimerComponent, TimerProgressComponent, TimerOptionsComponent, ProgressBarComponent, IntervalComponent, CountdownTimerComponent, FoodFindComponent, NutrientChartComponent, BenefitsComponent, MacrosComponent, IntervalCountdownComponent]
})
export class SharedModule { }
